<template>
  <div id="guidList" :class="[done?'done':'']">
    <div id="top" :class="['top', slideDown?'spread':'']">
      <div class="mobileTop"></div>
      <div class="topPart">
        <span class="backToApp" @click="back()"></span>
      </div>
      <div class="guid">
        <ul class="guidList">
          <li class="shake" v-for="(item,index) in iconList" :key="index">
            <div class="tabs" @click.stop.prevent="showList(index)">
              <div :class="['colorAnimate',activeTab == index?'active':'']">
                <img :src="item.url" alt="" class="icon">
              </div>
              <p class="name">{{item.name}}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div :class="['loader',fakeloading?'':'hide']"></div>
    <div :class="['card',up?'switch':'']">
      <ul class="goods">
        <li class="slidePart" @click="goDetail(item,index)" v-for="(item,index) in goodsList" :key="index">
          <div class="goodsItem">
              <img :src="item.cover" alt="" class="cover">
              <p class="name">{{ item.goodsName }}</p>
              <p class="price">￥<span class="dot">{{ item.price }}</span></p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import goodsListJson from './goods_pro.json'
export default {
  data () {
    return {
      jsonGoods: goodsListJson,
      goodsList: [],
      up: false,
      // padding: 0,
      fakeloading: true,
      activeTab: '',
      done: false,
      slideDown: false,
      iconList: [
        {
          url: require('./images/bell.png'),
          name: '应急'
        },
        {
          url: require('./images/extinguish.png'),
          name: '灭火'
        },
        {
          url: require('./images/protect.png'),
          name: '防护'
        },
        {
          url: require('./images/escape.png'),
          name: '逃生'
        },
        {
          url: require('./images/safebeg.png'),
          name: '安全包'
        }
      ]
    }
  },
  created () {
    this.done = true
    this.activeTab = this.$route.query.tab
    this.setJson(parseInt(this.activeTab))
    setTimeout(() => {
      this.fakeloading = false
      this.slideDown = true
      setTimeout(() => {
        this.up = true
      }, 1600)
    }, 800)
  },
  mounted () {
  },

  methods: {
    goDetail (item, key) {
      let dom = [...document.querySelectorAll('.slidePart')]
      dom.forEach((e, index) => {
        if (key == index) {
          e.classList.add('shake')
        }
      })
      setTimeout(() => {
        this.$router.push({
          path: '/myGoods',
          query: {
            goodsId: item.goods_id,
            businessId: item.business_id
          }
        })
      }, 300)
    },
    setJson (key) {
      switch (key) {
        case 0:
          this.goodsList = this.jsonGoods.bell
          break
        case 1:
          this.goodsList = this.jsonGoods.extinguish
          break
        case 2:
          this.goodsList = this.jsonGoods.protect
          break
        case 3:
          this.goodsList = this.jsonGoods.escape
          break
        case 4:
          this.goodsList = this.jsonGoods.safebeg
          break
      }
    },
    showList (key) {
      let dom = [...document.querySelectorAll('.slidePart')]
      dom.forEach((e, index) => {
        e.classList.remove('shake')
      })
      this.up = false
      this.fakeloading = true
      this.activeTab = key
      this.setJson(key)
      setTimeout(() => {
        this.fakeloading = false
        this.up = true
      }, 500)
    },
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
* {
margin: 0;
padding: 0;
}
.hide{
  display: none !important;
}
@keyframes spread-full {
  0%{
    width: 0px;
    height: 0px;
    border-radius: 50%;
  }
  30%{
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
  60%{
    width: 45px;
    height: 45px;
    border-radius: 50%;
  }
  90%{
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  100%{
    width: 60px;
    height: 60px;
    border-radius: 5px;
  }
}
#guidList{
  display: inline-block;
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background: url('./images/bg.svg') top no-repeat,#ffffff;
  background-position-y: -160px;
  padding:0 16px;
  &.done{
    background-image: none;
    background-color:#f5f5f5;
    background-size: 50%;
  }
  .top{
    overflow: hidden;
    width: 100%;
    height: 0px;
    position: fixed;
    top: 0;
    left: 0;
    background: #ffffff;
    padding:0 16px;
    z-index: 100;
    &.spread{
      height: 173px;
      transition: height 0.5s ease-in-out;
    }
    .mobileTop{
    height: 27px;
  }
  .topPart{
    display: inline-block;
    width: 100%;
    height: 30px;
    position: relative;
    margin-bottom:16.5px;
    .backToApp{
      display: inline-block;
      position: relative;
      width: 30px;
      height: 30px;
      line-height: 30px;
      &::before{
        content: '';
        position: absolute;
        left: 0;
        top: calc(50% - 6px);
        right: 0;
        margin: 0 auto;
        width: 12px;
        height: 12px;
        border-top: 2px solid #1D2129;
        border-left: 2px solid #1D2129;
        transform: rotate(-45deg);
      }
    }
  }
  .guidList{
      display: inline-block;
      width: 100%;
      overflow-x: auto;
      li{
        display: inline-block;
        width:60px;
        height: 90px;
        margin-right: 10px;
        overflow: hidden;
        .tabs{
          display: inline-block;
          .colorAnimate{
            position: relative;
            text-align: center;
            padding: 15px;
            text-align: center;
            border-radius: 5px;
            width: 60px;
            height: 60px;
            margin-bottom: 10px;
            .icon{
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 26px;
              height: 26px;
              border-radius: 5px;
            }
            &::before{
              content:'';
              position:absolute;
              width: 60px;
              height: 60px;
              background: #F6F6F6;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
            &.active::before{
              animation: spread-full 0.3s ease-in forwards;
              background: #F5EDE2;
            }
          }
          .name{
            display: inline-block;
            width: 60px;
            height: 13px;
            line-height: 13px;
            color: #000000;
            font-size: 14px;
            font-weight: bold;
            text-align: center;
          }
        }
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
  .card{
    position: absolute;
    padding-top: calc(100vh + 178px);
    padding-left: 15px;
    padding-right: 15px;
    height: 100vh;
    width: 100vw;
    left: 0;
    bottom: 0;
    opacity: 0;
    visibility: hidden;
    &.switch{
      opacity: 1;
      visibility: visible;
      padding-top: 178px;
      transition: all 1s ease-in-out;
    }
    .goods{
      display: inline-block;
      width: 100%;
      overflow-x: auto;
      .slidePart{
        position: relative;
        display: inline-block;
        height: 265px;
        width: 165px;
        margin-right: 10px;
        background: #ffffff;
        margin-bottom: 10px;
        border-radius: 10px;
        padding: 24px 10px 10px 10px;
        overflow: hidden;
        .goodsItem{
          position: relative;
          vertical-align: top;
          display: inline-block;
          text-align: center;
          width: 100%;
          .cover{
            display: inline-block;
            width: 140px;
            height: 140px;
            border-radius: 5px;
            margin-bottom: 20px;
          }
          .name{
            display: inline-block;
            position: relative;
            text-align: left;
            line-height: 15px;
            width: 100%;
            height: 15px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #1D2129;
            margin-bottom: 32px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .price{
            text-align: left;
            font-size: 12px;
            color: #9e918b;
            height: 18px;
            .dot{
              font-size: 18px;
              color: #9e918b;
              line-height: 18px;
              display: inline-block;
              margin-left: 2px;
            }
          }
          &::after{
              content:'';
              position: absolute;
              width: 66px;
              height: 19px;
              background: url('./images/vip.png')no-repeat center center;
              background-size: contain;
              left: 0;
              bottom: 25px;
            }
        }
        &:nth-child(2n){
          margin-right: 0;
        }
        // &::before{
        //   content: '';
        //   position: absolute;
        //   left: 0;
        //   bottom: 0;
        //   width: 0;
        //   height: 0;
        //   border-radius: 50%;
        // }
        &::after{
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 0;
          height: 0;
          border-radius: 50%;
        }
        &.shake{
          position: relative;
          &::after{
            content: '';
            position: absolute;
            background: rgba(158, 145, 139,0.7);
            left: -80px;
            bottom: -130px;
            width: 200%;
            height: 200%;
            transition: all 0.5s ease-in-out;
          }
        }
      }
      &::-webkit-scrollbar{
        display:none;
      }
    }
  }
  /* loading.css */
  .loader {
    color: #c41335;
    font-size: 90px;
    text-indent: -9999em;
    overflow: hidden;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    margin: 72px auto;
    position: absolute;
    top:calc(50% - 1em);
    left: calc(50% - 0.5em);
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load 1.7s infinite ease, round 1.7s infinite ease;
    animation: load 1.7s infinite ease, round 1.7s infinite ease;
  }
  @-webkit-keyframes load {
    0% {
      box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
    }
    5%,
    95% {
      box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
    }
    10%,
    59% {
      box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em, -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em, -0.297em -0.775em 0 -0.477em;
    }
    20% {
      box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em, -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em, -0.749em -0.34em 0 -0.477em;
    }
    38% {
      box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em, -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em, -0.82em -0.09em 0 -0.477em;
    }
    100% {
      box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
    }
  }
  @keyframes load {
    0% {
      box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
    }
    5%,
    95% {
      box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
    }
    10%,
    59% {
      box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em, -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em, -0.297em -0.775em 0 -0.477em;
    }
    20% {
      box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em, -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em, -0.749em -0.34em 0 -0.477em;
    }
    38% {
      box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em, -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em, -0.82em -0.09em 0 -0.477em;
    }
    100% {
      box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
    }
  }
  @-webkit-keyframes round {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes round {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  &::-webkit-scrollbar{
        display:none;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/manman/guidList.vue